var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45.936,
    height: 58.434,
    viewBox: "0 0 45.936 58.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 45.936,
    height: 58.434,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    opacity: 0.174
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M81.3,58.321H44.028a2.311,2.311,0,0,1-2.308-2.308V2.308A2.311,2.311,0,0,1,44.028,0H74.942L83.6,8.661V56.013A2.311,2.311,0,0,1,81.3,58.321",
    transform: "translate(-37.667)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M0,227.713l4.5,4,.3-4Z",
    transform: "translate(0 -205.59)",
    fill: "#c32120"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M80.136,59.48H42.869a2.311,2.311,0,0,1-2.308-2.308V3.467a2.311,2.311,0,0,1,2.308-2.308H73.783L82.444,9.82V57.172a2.311,2.311,0,0,1-2.308,2.308M42.869,2.285a1.183,1.183,0,0,0-1.182,1.182V57.172a1.183,1.183,0,0,0,1.182,1.182H80.136a1.183,1.183,0,0,0,1.182-1.182V10.287l-8-8Z",
    transform: "translate(-36.62 -1.046)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M381.27,13.854a2.59,2.59,0,0,0,2.59,2.59H389.6L381.27,8.112Z",
    transform: "translate(-344.228 -7.324)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 32.876,
    height: 13.792,
    transform: "translate(0 8.332)",
    fill: "#f0544a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M62.234,111.574h2.989c1.908,0,3.456.694,3.456,2.8,0,2.042-1.561,2.949-3.4,2.949H64.2v2.949H62.234Zm2.922,4.19c1.081,0,1.6-.48,1.6-1.388s-.587-1.241-1.655-1.241H64.2v2.629Z",
    transform: "translate(-56.188 -100.734)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M144.1,111.575h2.455c2.655,0,4.363,1.321,4.363,4.31s-1.708,4.39-4.257,4.39H144.1Zm2.335,7.112c1.481,0,2.468-.721,2.468-2.8s-.987-2.722-2.468-2.722h-.374v5.524Z",
    transform: "translate(-130.098 -100.735)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M231.32,111.574H236.8v1.655h-3.523v2.015H236.3V116.9h-3.016v3.376H231.32Z",
    transform: "translate(-208.847 -100.734)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 11.958,
    height: 1.625,
    transform: "translate(24.296 30.399)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 11.958,
    height: 1.625,
    transform: "translate(24.296 36.087)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 22.743,
    height: 1.625,
    transform: "translate(13.511 41.776)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 11.709,
    height: 1.625,
    transform: "translate(13.511 47.464)",
    fill: "#c9c9c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M145.686,319.2h-5.27v-4.954h5.27Zm1.351-6.3h-7.972v7.656h7.972Z",
    transform: "translate(-125.554 -282.498)",
    fill: "#c9c9c9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPdf);
export default __webpack_public_path__ + "static/media/big_pdf.fc29409d1f01783f7da25e724567ffa0.svg";
export { ForwardRef as ReactComponent };